<nz-modal class="room-modal" [(nzVisible)]="isVisible" [nzTitle]="data?.id ? 'Edit Room' : 'Add a New Room'"
  [nzMaskClosable]="false" (nzOnCancel)="handleCancel()" [nzFooter]="modalFooter" [nzWidth]="'90vw'"
  [nzStyle]="{ top: '40px' }">
  <ng-container *nzModalContent>
    <form nz-form [formGroup]="roomForm" class="room-form">

      <!-- Left and Right columns handled by CSS grid -->


      <nz-form-item>
        <nz-form-label nzRequired>Room Type</nz-form-label>
        <nz-form-control>
          <nz-select formControlName="room_type" nzPlaceHolder="Select type">
            <nz-option [nzValue]="1" nzLabel="Meeting"></nz-option>
            <nz-option [nzValue]="2" nzLabel="Guest"></nz-option>
            <nz-option [nzValue]="3" nzLabel="Conference"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzRequired>Room Name</nz-form-label>
        <nz-form-control>
          <input nz-input formControlName="room_name" placeholder="Enter room name" />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzRequired>Room Length (m)</nz-form-label>
        <nz-form-control>
          <input nz-input type="number" formControlName="room_length" />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzRequired>Max Capacity</nz-form-label>
        <nz-form-control>
          <input nz-input formControlName="max_capacity" placeholder="Enter max capacity" />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label>Seating - Theatre</nz-form-label>
        <nz-form-control>
          <input nz-input type="number" formControlName="seating_capacity_theatre" />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label>Seating - Long Table</nz-form-label>
        <nz-form-control>
          <input nz-input type="number" formControlName="capacity_long_table" />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label>Seating - Classroom</nz-form-label>
        <nz-form-control>
          <input nz-input type="number" formControlName="capacity_classroom" />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label>Seating - Boardroom</nz-form-label>
        <nz-form-control>
          <input nz-input type="number" formControlName="capacity_boardroom" />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label>Seating - Banquet</nz-form-label>
        <nz-form-control>
          <input nz-input type="number" formControlName="capacity_banquet_rounds" />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label>Seating - U-shape</nz-form-label>
        <nz-form-control>
          <input nz-input type="number" formControlName="capacity_u_shape" />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label>Seating - Reception</nz-form-label>
        <nz-form-control>
          <input nz-input type="number" formControlName="capacity_reception_standing" />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label>Total Space (sq. m)</nz-form-label>
        <nz-form-control>
          <input nz-input type="number" formControlName="total_space" />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label>Ceiling Height (ft.)</nz-form-label>
        <nz-form-control>
          <input nz-input type="number" formControlName="ceiling_height" />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label>Natural Light</nz-form-label>
        <nz-form-control>
          <label nz-checkbox formControlName="natural_light">Available</label>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label>Soundproofing</nz-form-label>
        <nz-form-control>
          <label nz-checkbox formControlName="soundproofing">Available</label>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item class="full-width">
        <nz-form-label>Room Specifications</nz-form-label>
        <nz-form-control>
          <textarea nz-input rows="3" formControlName="room_specifications"
            placeholder="Enter specifications"></textarea>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label>Breakout Rooms</nz-form-label>
        <nz-form-control>
          <input nz-input formControlName="breakout_rooms" placeholder="e.g. 2 rooms, 20 capacity each" />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label>In-house AV</nz-form-label>
        <nz-form-control>
          <label nz-checkbox formControlName="in_house_av">Available</label>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label>Stage Availability</nz-form-label>
        <nz-form-control>
          <label nz-checkbox formControlName="stage_availability">Available</label>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label>LED Wall</nz-form-label>
        <nz-form-control>
          <input nz-input formControlName="led_wall" placeholder="Enter details" />
        </nz-form-control>
      </nz-form-item>


      <!-- TV Available -->
      <nz-form-item>
        <nz-form-label>TV Available</nz-form-label>
        <nz-form-control>
          <label nz-checkbox formControlName="tv">Available</label>

          <!-- Nested input, no extra nz-form-label -->
          <div *ngIf="roomForm.get('tv')?.value" class="nested-input">
            <input nz-input type="number" placeholder="TV Size (inch)" formControlName="tv_size" />
          </div>
        </nz-form-control>
      </nz-form-item>

      <!-- Projector -->
      <nz-form-item>
        <nz-form-label>Projector and Screen</nz-form-label>
        <nz-form-control>
          <label nz-checkbox formControlName="projector_and_screen">Available</label>

          <div *ngIf="roomForm.get('projector_and_screen')?.value" class="nested-input">
            <input nz-input type="number" placeholder="Screen Size (inch)" formControlName="screen_size" />
          </div>
        </nz-form-control>
      </nz-form-item>



      <!-- Media Links -->
      <nz-form-item class="full-width">
        <div class="media-links-container">
          <div class="media-links-header">
            <span class="title mdeia-link-title">Media Links :</span>
            <!-- <button nz-button nzType="primary" (click)="openAddLink()">+ Add</button> -->
             <button nz-button nzType="link" (click)="openAddLink()">
             <!-- + <nz-icon nzType="link" nzTheme="outline" style="font-size: 15px;"  /> -->
              + Add
            </button>

          </div>

          <nz-table [nzBordered]="true" [nzData]="mediaLinks" [nzLoading]="loading" [nzSize]="'small'">
            <thead>
              <tr>
                <th>Name</th>
                <th>URL</th>
                <th>Type</th>
                <th style="width: 120px;">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let link of mediaLinks; let i = index">
                <td>{{ link.name }}</td>
                <td><a [href]="link.url" target="_blank">{{ link.url }}</a></td>
                <td>{{ link.type_name }}</td>
                <td>
                  <button nz-button nzType="link" (click)="openEditLink(link,i)">Edit</button>
                  <button
                    class="custom-popconfirm"
                    nz-button nzType="link" nzDanger
                    nz-popconfirm
                    [nzPopconfirmOverlayClassName]="'custom-popconfirm-popover'"
                    [nzPopconfirmTitle]="popconfirmTpl"
                    nzPopconfirmPlacement="bottom"
                    (nzOnConfirm)="deleteMediaLink(link.id,i)"
                  >
                    Delete
                  </button>
                <!-- Custom Popconfirm Template for Delete Confirmation -->
                <ng-template #popconfirmTpl let-popconfirm="popconfirm">
                  <div class="custom-popconfirm-header">
                    <span class="custom-popconfirm-title">Confirm Deletion</span>
                  </div>
                  <div class="custom-popconfirm-icon-area">
                    <span style="display: flex; justify-content: center; margin: 18px 0 8px 0;">
                      <nz-icon nzType="warning-fill" nzTheme="fill" style="font-size: 32px; color: #ff6c6c;"></nz-icon>
                    </span>
                  </div>
                  <div class="custom-popconfirm-message description">
                    Are you sure you want to delete this item?<br />
                    <span style="color:#888; font-size:14px;">This action cannot be undone.</span>
                  </div>
                  <!-- <div class="custom-popconfirm-footer" style="display: flex; justify-content: flex-end; gap: 8px; margin-top: 24px;">
                    <button nz-button nzType="default" class="custom-delete-modal__cancel" (click)="$event.stopPropagation(); popconfirm?.nzCancel.emit()">Cancel</button>
                    <button nz-button nzType="primary" nzDanger class="custom-delete-modal__ok" (click)="$event.stopPropagation(); popconfirm?.nzConfirm.emit()">
                      <nz-icon nzType="delete" nzTheme="outline" style="margin-right: 4px;"></nz-icon>OK
                    </button>
                  </div> -->
                </ng-template>
                </td>
              </tr>
            </tbody>
          </nz-table>
        </div>
      </nz-form-item>



    </form>
  </ng-container>

  <ng-template #modalFooter>
    <button nz-button nzType="default" (click)="handleCancel()">Cancel</button>
    <button nz-button nzType="primary" (click)="save()">
      {{ data?.id ? "Update" : "Save" }}
    </button>
  </ng-template>
</nz-modal>
